// const hostUrl = 'https://api.reghubchina.com'
// export const baseURL = process.env.NODE_ENV === 'production' ? hostUrl : 'https://api.reghubchina.com';
// const hostUrl = 'http://192.168.1.105:8848'
const hostUrl = 'https://api.reghubchina.com';
export const baseURL = process.env.NODE_ENV === 'production' ? hostUrl : 'https://api.reghubchina.com';